<div nxLayout="grid maxwidth" class="d-flex h-100 justify-content-center">
  <div nxRow nxRowAlignItems="center">
    <div nxCol="12" class="docs-grid-colored-col">
      <cpc-maintenance-page [phoneNumber]="phoneNumber" [maintenanceText]="maintenanceText"></cpc-maintenance-page>
    </div>
  </div>
</div>

